const input = {
    username: '用戶名',
    password: '密碼',
    email: '電子郵件',
    phone_number: '手機號碼',
    confirm_password: '確認密碼',
    search_region_code: '搜尋區域碼',
    backup_code: '備用碼',
    code: '代碼',
    label_with_optional: '{{label}}（可選）',
    email_address: '電子郵件地址',
    email_placeholder: '輸入你的電子郵件',
    enter_email: '輸入電子郵件',
};
export default Object.freeze(input);
